<script lang="ts">
  import { getAppConfig } from '../../../../common/config/app-config';
  import Tag from './Tag.svelte';
  const { primeLevel, isMegaSaleDayXStarted, joodMegaSaleTag, isMegaSaleDuringAccessStarted } = getAppConfig();

  export let productTags;
  if (productTags && productTags.length > 0) {
    productTags.map(x => {
      if (x.productStatus === 'JOOD_DAY') {
        delete x.textColorCode;
      }
    });
  }
  const getMegaSaleStyleDetails = (tag, type) => {
    if (tag?.productStatus === joodMegaSaleTag) {
      if (!tag?.[type] || tag?.[type] == '' || tag?.[type] == null) return type;
    }
    return '';
  };
</script>

{#if productTags}
  <section class="tag-container">
    {#each productTags as tag}
      {#if (isMegaSaleDayXStarted && tag?.productStatus === joodMegaSaleTag) || (isMegaSaleDuringAccessStarted && tag?.productStatus === joodMegaSaleTag && primeLevel)}
        <Tag
          {...tag}
          megaSaleTextFlag={getMegaSaleStyleDetails(tag, 'backgroundColorCode')}
          megaSaleBgFlag={getMegaSaleStyleDetails(tag, 'textColorCode')}
        />
      {:else if tag?.productStatus != joodMegaSaleTag}
        <Tag {...tag} />
      {/if}
    {/each}
  </section>
{/if}

<style lang="scss">
  @import '../../styles/colors.new.scss';
  .tag-container {
    display: flex;
    gap: 4px;
    padding: 8px 16px 0;
    margin-bottom: 10px;

    @include desktop-min-width {
      background-color: transparent;
      padding: 8px 0px 0;
    }
  }
</style>
